module.exports = __webpack_public_path__ + "img/attendance-ussd.0b563fdb.svg";